import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { trackAdobeClick } from "../../utils/adobeLogging";

const item = "bg-transparent rounded-tl-xxl pt-4 pb-2 px-6 block text-white";
const hover = "bg-transparent hover:bg-white hover:text-black rounded-tl-xxl";

const TabLink = ({ url, index, color, title, tabIndex }) => {
  const section = useSelector((state) => state.progress.section);

  const active =
    "bg-transparent rounded-tl-xxl pt-4 pb-2 px-6 block bg-white text-black";

  return (
    <Link
      onClick={() => {
        trackAdobeClick(null, {
          linkTitle: title,
          linkModule: `${section}-module-page`,
          targetURL: url,
        });
      }}
      to={url}
      className={`${hover} ${index === tabIndex ? active : item} `}
    >
      <span>{title}</span>
    </Link>
  );
};

const ContentTabs = ({
  partIndex,
  title1,
  title2,
  title3,
  url,
  color,
  topic,
}) => {
  const activity = topic && topic.data && topic.data.activity;
  const { t } = useTranslation();

  return (
    <>
      <div
        className={`bg-${color} text-black font-bold rounded-tl-xxl shadow-xl`}
      >
        <div className="pt-2">
          <ul className={`flex justify-around text-xs align-bottom my-0 py-0`}>
            <li className="flex">
              <TabLink
                color={color}
                index={partIndex}
                title={title1}
                tabIndex={1}
                url={`${url}/1`}
              />
            </li>
            <li className="flex">
              <TabLink
                color={color}
                index={partIndex}
                title={title2}
                tabIndex={2}
                url={`${url}/2`}
              />
            </li>
            <li className="flex">
              <TabLink
                color={color}
                index={partIndex}
                title={title3}
                tabIndex={3}
                url={`${url}/3`}
              />
            </li>
            {activity && activity.hasActivity && (
              <li className="flex">
                <TabLink
                  color={color}
                  index={partIndex}
                  tabIndex={4}
                  title={t("Activity")}
                  url={`/app/activity/${activity.activityKey}`}
                />
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ContentTabs;
